var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Severity Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66602 11.3457C4.66602 6.92743 8.24774 3.3457 12.666 3.3457C14.7877 3.3457 16.8226 4.18856 18.3229 5.68885C19.8232 7.18914 20.666 9.22397 20.666 11.3457C20.666 15.764 17.0843 19.3457 12.666 19.3457C8.24774 19.3457 4.66602 15.764 4.66602 11.3457ZM12.45 14.2337L16.106 9.4337V9.4097C16.2804 9.18105 16.3195 8.87676 16.2086 8.61145C16.0978 8.34613 15.8538 8.16011 15.5686 8.12345C15.2834 8.08678 15.0004 8.20505 14.826 8.4337L11.802 12.4337L10.498 10.7697C10.3222 10.5439 10.0394 10.429 9.75593 10.4684C9.4725 10.5077 9.23159 10.6953 9.12393 10.9604C9.01628 11.2255 9.05824 11.5279 9.23402 11.7537L11.186 14.2417C11.3387 14.4349 11.5718 14.547 11.818 14.5457C12.0656 14.5451 12.299 14.4299 12.45 14.2337Z",
    fill: "#31BF7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityLow);
export default __webpack_public_path__ + "static/media/severityLow.01b2f9e34109b8a44d11277609ae96b3.svg";
export { ForwardRef as ReactComponent };